dealCarouselTemplate = require '../main.html.mustache'

showDealCarousel = ->
  $mainContent = $ '.mpp-container .main-content'
  $rightRail = $ '.mpp-container .main-content-right-column'
  return false unless $mainContent.length && $rightRail.length

  # Do not add the deal carousel if the righthand rail is already larger than the main content.
  if $rightRail.height() >= $mainContent.height()
    return false
  else
    return true

class DealCarousel

  constructor: (@el, @deals) ->
    @$el = $ @el
    @render()

    @$jcarousel = @$el.find '.jcarousel'

    @initJCarousel()
    @initBindings()
    @scrollAutomatically()

  render: ->
    templateData = { deals: @deals }
    templateData.translate = templateData.t = -> (text) -> I18n.translate text
    html = dealCarouselTemplate.render templateData
    @$el.html html
    @$el.slideDown ->
      GIG.Utils.truncateElements @$el

  onResize: ->
    return unless @$el.is ':visible'
    clearTimeout(@resizeTimer) if @resizeTimer?
    @resizeTimer = setTimeout (=>
      @destroyJCarousel()
      @initJCarousel()
    ), 250

  initBindings: ->
    @$el.find('.arrows .next').click => @moveNext()
    @$el.find('.arrows .back').click => @moveBack()

    $(window).on 'resize', => @onResize()

  initJCarousel: ->
    width = @$jcarousel.outerWidth()
    @$jcarousel.find('li').css 'width', "#{width}px"
    @$jcarousel.jcarousel { wrap: 'circular' }
    @jcarousel = @$jcarousel.data 'jcarousel'
    $jcarouselUl = @$jcarousel.find 'ul'
    $jcarouselUl.css 'left', 0
    $jcarouselUl.scrollTo 0, { axis: 'x' }

  destroyJCarousel: ->
    @jcarousel.destroy()

  moveNext: ->
    @jcarousel.scroll '+=1'
    @scrollAutomatically()

  moveBack: ->
    @jcarousel.scroll '-=1'
    @scrollAutomatically()

  scrollAutomatically: ->
    clearInterval(@scrollTimeout) if @scrollTimeout?
    @scrollTimeout = setInterval (=>
      @moveNext()
      @scrollAutomatically()
    ), 10000

exports.DealCarousel = DealCarousel

$ ->
  # do nothing if right rail is not present (mobile)
  return unless $('.mpp-container .main-content-right-column').length > 0

  # do not show the carousel if the MPP has deals
  return if $('.mpp-container #multiple-offers .mpp-deal-card').length > 0

  # do not show the carousel if the righthand rail is already larger than the main content
  return unless showDealCarousel()

  $('.mpp-container').on 'nearby-deals-loaded', (event, nearbyDeals) ->
    new DealCarousel('.mpp-container .main-content-right-column .deal-carousel', nearbyDeals.markers)

    if $('.mpp-container .main-content-right-column .deal-carousel.sem').length > 0
      $('.mpp-container .main-content-right-column .photo-tiles').css 'margin-top', '20px'
